import React, { useEffect, useState } from "react";
import "./shareUsingMail.css";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import useAxios from "../../Hooks/useAxios";

const ShareUsingMail = ({
  setShareUsingMail,
  setShareGalleryLinkPopup,
  password,
  url,
}) => {
  console.log(password, url);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [toEmails, setToEmails] = useState([]);
  const [ccMails, setCCMails] = useState([]);
  const [bccMails, setBCCMails] = useState([]);
  const [showCCBCC, setShowCCBCC] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const axios = useAxios();
  const navigate = useNavigate();

  const handleShowCCBCC = () => {
    setShowCCBCC((prev) => !prev);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const emailData = {
      to: toEmails,
      cc: ccMails,
      bcc: bccMails,
      url: url,
      password: password,
      customer_name: customerName,
    };
    console.log(emailData);

    if (emailData.to.length > 0) {
      try {
        const response = await axios.post(
          backend_base + "/shop/gallery-share/mail",
          emailData
        );
        // Clear the form after submission
        if (response.status === 200 || response.status === 201) {
          setToEmails([]);
          setCCMails([]);
          setBCCMails([]);
          navigate("/gallery-share-success");
        }
      } catch (error) {
        console.error("Error sending email:", error);
        alert(error.message);
      }
    } else {
      alert("Please add an email");
    }
  };

  useEffect(() => {
    axios
      .get(backend_base + "/user/details")
      .then((res) => {
        console.log(res.data);
        setCustomerName(
          res.data?.kanji_first_name + " " + res.data?.kanji_last_name
        );
      })
      .catch((e) => console.log("failed to fetch user data"));
  }, []);

  return (
    <div className="mail-main">
      <div className="mail-main-header">
        宛先をご入力ください。本文は編集できません。
      </div>
      <div className="header-bottom-stylish-line"></div>
      <div className="mail-box">
        <div className="d-flex justify-content-start p-4 bg-white mail-box-top-div">
          <button
            className="btn bg-white"
            onClick={() => {
              setShareGalleryLinkPopup(true);
              setShareUsingMail(false);
            }}
          >
            <BsArrowLeft fontSize={"20px"} />
          </button>
          <button className="btn mail-send-btn" onClick={handleSubmit}>
            送信
          </button>
        </div>
        <div className="mail-form">
          <EmailField
            label="To"
            emails={toEmails}
            setEmails={setToEmails}
            handleShowCCBCC={handleShowCCBCC}
          />
          {showCCBCC && (
            <>
              <EmailField label="Cc" emails={ccMails} setEmails={setCCMails} />
              <EmailField
                label="Bcc"
                emails={bccMails}
                setEmails={setBCCMails}
              />
            </>
          )}
          <div className="input-field">
            <label>From</label>
            <input
              type="text"
              value={"info@myace.shop"}
              style={{ fontWeight: 500 }}
            />
          </div>
          <div className="input-field">
            <input
              className="subject"
              type="text"
              value={"My AceギャラリーURL共有のお知らせ"}
              style={{ padding: 0 }}
            />
          </div>
          <div className="input-field">
            <div className="mail-body">
              <div>{customerName}様より</div>
              <div>Acestudioで撮影した写真データが届いております。</div>
              <br />
              <div>
                下記URLをクリックし【合言葉】を入力すると写真をご覧いただけます。
                合言葉は設定者にご確認ください。 <br /> <br />
              </div>
              <div>ギャラリーのURL：https//〜〜〜</div> <br /> <br />
              <div>
                ーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
                <br /> <br />
                ※このメールは送信専用メールアドレスから配信されています。
                ご返信いただいてもお答えできませんので、ご了承ください。
                <br /> <br />
                ーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const EmailField = ({ label, emails, setEmails, handleShowCCBCC }) => {
  const [currentEmail, setCurrentEmail] = useState("");
  const [isInputEnabled, setIsInputEnabled] = useState(
    emails.length === 0 ? true : false
  );

  const handleEmailChange = (event) => {
    setCurrentEmail(event.target.value);
  };

  const handleEmailKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      const trimmedEmail = currentEmail.trim();

      if (trimmedEmail !== "") {
        const emailList = emails;

        if (emailList.includes(trimmedEmail)) {
          // Alert the user about duplicate email
          alert("This email is already added.");
        } else {
          setEmails([...emails, trimmedEmail]);
        }

        setCurrentEmail("");
        setIsInputEnabled(false);
      }
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    const updatedEmails = emails.filter((email) => email !== emailToRemove);
    setEmails(updatedEmails);
    if (updatedEmails.length === 0) {
      setIsInputEnabled(true);
    }
  };

  const handleAddMoreEmails = () => {
    setIsInputEnabled(true);
    setCurrentEmail("");
  };

  return (
    <div
      className={`d-flex justify-content-between align-items-center input-field ${
        label === "To" ? "" : "cc-field"
      }`}
    >
      <label className="label">{label}</label>
      <div className="email-tags w-100">
        {emails.map((email) => (
          <div key={email} className="email-tag">
            {email}
            <span
              className="tag-close"
              onClick={() => handleRemoveEmail(email)}
            >
              &times;
            </span>
          </div>
        ))}
        {isInputEnabled ? (
          <input
            className="input email-input"
            type="text"
            value={currentEmail}
            onChange={handleEmailChange}
            onKeyDown={handleEmailKeyDown}
            // placeholder={`Enter ${label} email and press space...`}
          />
        ) : (
          <button
            className={`btn plus-btn ${emails.length === 0 ? "hidden" : ""}`}
            onClick={handleAddMoreEmails}
          >
            +
          </button>
        )}
      </div>
      {label === "To" && (
        <div className="d-flex" onClick={handleShowCCBCC}>
          <button type="button" className="ccbcc">
            Cc
          </button>
          <button type="button" className="ccbcc">
            Bcc
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareUsingMail;
